module.exports = __webpack_public_path__ + "img/Logo-white.5b30e784.png";